import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/ConsentBanner.css";

const ConsentBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check if user has already given consent
    try {
      const consent = localStorage.getItem("fer-al-consent");
      if (!consent) {
        // Show banner after a short delay for better UX
        const timer = setTimeout(() => {
          setShowBanner(true);
        }, 1000);
        return () => clearTimeout(timer);
      }
    } catch (error) {
      // If localStorage is not available, show the banner
      console.warn("localStorage not available:", error);
      const timer = setTimeout(() => {
        setShowBanner(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    // Store consent in localStorage with timestamp
    try {
      const consentData = {
        accepted: true,
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem("fer-al-consent", JSON.stringify(consentData));
    } catch (error) {
      console.warn("Failed to store consent in localStorage:", error);
    }
    setShowBanner(false);
  };

  const handleReject = () => {
    // Store rejection in localStorage with timestamp
    try {
      const consentData = {
        accepted: false,
        timestamp: new Date().toISOString(),
      };
      localStorage.setItem("fer-al-consent", JSON.stringify(consentData));
    } catch (error) {
      console.warn("Failed to store consent in localStorage:", error);
    }
    setShowBanner(false);
  };

  if (!showBanner) {
    return null;
  }

  return (
    <div className="consent-banner" role="dialog" aria-labelledby="consent-title" aria-describedby="consent-description">
      <div className="consent-content">
        <h2 id="consent-title" className="consent-title">Privacy e Cookie</h2>
        <p id="consent-description" className="consent-description">
          Questo sito non utilizza cookie di tracciamento o profilazione. Utilizziamo solo un cookie tecnico 
          per memorizzare la tua preferenza riguardo a questa informativa. 
          Visitando il sito, accetti la nostra{" "}
          <Link to="/privacy-policy" className="consent-link">Privacy Policy</Link> e la{" "}
          <Link to="/cookie-policy" className="consent-link">Cookie Policy</Link>.
        </p>
        <div className="consent-actions">
          <button 
            className="consent-btn consent-btn-accept" 
            onClick={handleAccept}
            aria-label="Accetta la privacy policy e cookie policy"
          >
            Accetta
          </button>
          <button 
            className="consent-btn consent-btn-reject" 
            onClick={handleReject}
            aria-label="Rifiuta (chiudi il banner)"
          >
            Rifiuta
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConsentBanner;
